import {
  AfterViewChecked, Component, ElementRef, Inject, Renderer2, ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LayoutBaseRenderComponent } from 'render/render-shared/layout-base-render/layout-base-render.component';
import { RenderSeoService } from 'render/services/render-seo.service';

import { LayoutHeaderFooterSettings } from './models/layout-header-footer.models';


@Component({
  selector: 'layout-header-footer-render',
  templateUrl: './layout-header-footer-render.component.html',
  styleUrls: ['./layout-header-footer-render.component.scss']
})
export class LayoutHeaderFooterRenderComponent
  extends LayoutBaseRenderComponent<LayoutHeaderFooterSettings>
  implements AfterViewChecked {

  public stickyFooter: boolean = false;

  @ViewChild('rollingHeader', { read: ElementRef })
  private readonly rollingHeader?: ElementRef<HTMLDivElement>;

  @ViewChild('header', { read: ElementRef })
  private readonly header?: ElementRef<HTMLDivElement>;

  @ViewChild('headerOverlap', { read: ElementRef })
  private readonly headerOverlap?: ElementRef<HTMLDivElement>;

  @ViewChild('slotContent', { read: ElementRef })
  private readonly slotContent?: ElementRef<HTMLDivElement>;

  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly seoService: RenderSeoService,
    @Inject('Window') private readonly window: Window,
    private readonly renderer: Renderer2
  ) {
    super(route, seoService);
  }

  public ngAfterViewChecked() {
    const rollingHeader = this.renderer.selectRootElement(this.rollingHeader)
      ?.nativeElement;
    const header = this.renderer.selectRootElement(this.header)?.nativeElement;
    const headerOverlap = this.renderer.selectRootElement(this.headerOverlap)?.nativeElement;
    const slotContent = this.renderer.selectRootElement(this.slotContent)?.nativeElement;
    const slotContentPosition = -headerOverlap.clientHeight;

    if (header.style.top !== rollingHeader.clientHeight) {
      headerOverlap.style.top = `${header.clientHeight}px`;
      slotContent.style.marginTop = `${slotContentPosition}px`;
    }
  }

  protected onInitHook(): void {
    this.stickyFooter = (this.layout?.settings?.general?.stickyFooter as boolean | undefined) ?? false;
  }

}
